import { FormType } from "../enums/common";
import { StripeRecurringInterval } from "../enums/payment";
import { countryHasAch } from "../internationalization/features/payment-methods";
const ONE_TIME_BANK_PRIORITY_MIN = 1_000_00;
const MONTHLY_DONATION_BANK_PRIORITY_MIN = 200_00;
const NEUTRAL_PAYMENT_STEP_MAX = 5_000_00;
export const shouldPrioritizeBankPayment = ({ amount, formType, organizationCountry, stripeRecurrenceInterval, }) => {
    if (amount >= ONE_TIME_BANK_PRIORITY_MIN) {
        return true;
    }
    return (formType === FormType.DonationForm &&
        stripeRecurrenceInterval === StripeRecurringInterval.month &&
        countryHasAch(organizationCountry) &&
        amount >= MONTHLY_DONATION_BANK_PRIORITY_MIN);
};
export const isNeutralPaymentStepSegment = ({ amount, organizationCountry, stripeRecurrenceInterval, }) => stripeRecurrenceInterval === null &&
    countryHasAch(organizationCountry) &&
    amount >= ONE_TIME_BANK_PRIORITY_MIN &&
    amount < NEUTRAL_PAYMENT_STEP_MAX;
